import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { TREATMENT_IS_PROGRESSING_COMMENT, TREATMENT_IS_PROGRESSING_TITLE } from '@constants/text';

function TreatmentIsProgressing(): ReactElement {
  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{TREATMENT_IS_PROGRESSING_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={7.5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col style={{ textAlign: 'center' }} yzTypeCol="center">
          <TypographyText style={{ whiteSpace: 'pre-wrap' }} yzTypeTypographyText="basic">
            {TREATMENT_IS_PROGRESSING_COMMENT}
          </TypographyText>
        </Col>
      </Row>
      <Divider margin={7.5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <img alt="end-img" src={`${process.env.PUBLIC_URL}/img/end-img.webp`} width="168px" />
        </Col>
      </Row>
    </Layout>
  );
}

export default TreatmentIsProgressing;
